module.exports = __webpack_public_path__ + "lu.svg?c401f0dc7815df70e4b867e9e91d3aa9";